export default __webpack_public_path__ + "static/media/remodel3b.3f15902a.png";